import { createBaseFields } from './baseSchema.js';

/**
 * Invite collection schema
 */
export const inviteSchema = {
    ...createBaseFields('', ''),
    code: { _value: '', _rule: 'this.size() == 6', _immutable: true },
    type: { _value: 'professional', _enum: ['professional', 'employer', 'universal', 'branch'], _immutable: true },
    status: { _value: 'active', _enum: ['active', 'claimed', 'revoked'] },
    createdBy: { _value: '', _rule: 'this.size() > 0', _immutable: true }, // UID of admin/user
    // claimedBy is set when status changes to 'claimed'
    claimedBy: { _value: '', _optional: true },
    claimedAt: { _value: null, _rule: 'this is timestamp', _optional: true },
    isUrlInvite: { _value: false, _immutable: true },
    organizationId: { _value: '', _optional: true, _immutable: true },
    usageCount: { _value: 0, _optional: true, _rule: 'this >= 0' }
};

/**
 * Create an invite document
 */
export const createInviteDocument = ({
    code,
    type,
    createdBy,
    isUrlInvite = false,
    organizationId = ''
}) => {
    const baseFields = createBaseFields(code, 'Invite ' + code); // Using code as UID/Display for base fields

    return {
        ...baseFields,
        code,
        type,
        status: 'active',
        createdBy,
        isUrlInvite: Boolean(isUrlInvite),
        ...(organizationId ? { organizationId } : {}),
        ...(type === 'branch' ? { usageCount: 0 } : {})
    };
};
